import React, { useState } from 'react';
import { Button } from './ui/button';
import { Phone, MapPin, Menu, X, Calculator, FileText, Search } from 'lucide-react';
import { advisorInfo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-md">
              <img 
                src="https://customer-assets.emergentagent.com/job_perodua-advisor/artifacts/bnpfbniz_IMG_4155.png" 
                alt="Perodua Logo"
                className="w-8 h-8 object-contain"
              />
            </div>
            <div>
              <h1 className="font-bold text-lg text-slate-900">Syasyah Perodua</h1>
              <p className="text-sm text-pink-600 font-medium">Trusted Advisor</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => window.open('/models', '_blank')} className="text-slate-700 hover:text-pink-600 font-medium transition-colors">
              Models
            </button>
            <button onClick={() => window.open('/calculator', '_blank')} className="text-slate-700 hover:text-pink-600 font-medium transition-colors flex items-center space-x-1">
              <Calculator className="w-4 h-4" />
              <span>Calculator</span>
            </button>
            <button onClick={() => window.open('/brochure', '_blank')} className="text-slate-700 hover:text-pink-600 font-medium transition-colors flex items-center space-x-1">
              <FileText className="w-4 h-4" />
              <span>Brochure</span>
            </button>
            <button onClick={() => window.open('/calculator-kelayakan', '_blank')} className="text-slate-700 hover:text-pink-600 font-medium transition-colors flex items-center space-x-1">
              <Search className="w-4 h-4" />
              <span>Kelayakan</span>
            </button>
            <button onClick={() => window.open('/colors', '_blank')} className="text-slate-700 hover:text-pink-600 font-medium transition-colors">
              Colors
            </button>
            <button onClick={() => window.open('/benefits', '_blank')} className="text-slate-700 hover:text-pink-600 font-medium transition-colors">
              Benefits
            </button>
            <button onClick={() => window.open('/testimonials', '_blank')} className="text-slate-700 hover:text-pink-600 font-medium transition-colors">
              Reviews
            </button>
          </nav>

          {/* Contact Info & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-sm text-slate-600">
              <Phone className="w-4 h-4" />
              <span className="font-medium">{advisorInfo.phone}</span>
            </div>
            <Button 
              onClick={() => window.open(`${advisorInfo.whatsappLink}?text=${encodeURIComponent('[Website] PM PERODUA - Hi Syasyah, saya dari website anda dan nak contact untuk kereta Perodua.')}`, '_blank')}
              className="bg-green-600 hover:bg-green-700 text-white font-medium px-6 py-2 rounded-lg transition-all duration-200 transform hover:scale-105"
            >
              WhatsApp
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-slate-700 hover:bg-slate-100 transition-colors"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-slate-200 py-4 space-y-3">
            <button onClick={() => window.open('/models', '_blank')} className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 font-medium">
              Models
            </button>
            <button onClick={() => window.open('/calculator', '_blank')} className="flex items-center w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 font-medium space-x-2">
              <Calculator className="w-4 h-4" />
              <span>Calculator</span>
            </button>
            <button onClick={() => window.open('/brochure', '_blank')} className="flex items-center w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 font-medium space-x-2">
              <FileText className="w-4 h-4" />
              <span>Brochure</span>
            </button>
            <button onClick={() => window.open('/calculator-kelayakan', '_blank')} className="flex items-center w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 font-medium space-x-2">
              <Search className="w-4 h-4" />
              <span>Semak Kelayakan</span>
            </button>
            <button onClick={() => window.open('/colors', '_blank')} className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 font-medium">
              Colors
            </button>
            <button onClick={() => window.open('/benefits', '_blank')} className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 font-medium">
              Benefits
            </button>
            <button onClick={() => window.open('/testimonials', '_blank')} className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-50 font-medium">
              Reviews
            </button>
            <div className="px-4 pt-2 border-t border-slate-200">
              <div className="flex items-center space-x-2 text-sm text-slate-600 mb-3">
                <Phone className="w-4 h-4" />
                <span className="font-medium">{advisorInfo.phone}</span>
              </div>
              <Button 
                onClick={() => window.open(`${advisorInfo.whatsappLink}?text=${encodeURIComponent('[Website] PM PERODUA - Hi Syasyah, saya dari website anda dan nak contact untuk kereta Perodua.')}`, '_blank')}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 rounded-lg"
              >
                WhatsApp Now
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;